<template>
  <div class="calendar">
    <div
      v-for="(day, index) in days"
      :key="index"
      :class="['day-card', { selected: selectedDate === day.dateKey }]"  @click="selectDate(day)">
      <div class="day-name">{{ day.dayName }}</div>
      <div class="date">{{ day.dateString }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Calendar",
  data() {
    return {
      days: [],
      selectedDate: null
    };
  },
  created() {
    this.generateDays();
  },
  methods: {
    generateDays() {
  const today = new Date();
  for (let i = 0; i < 30; i++) {
    const date = new Date();
    date.setDate(today.getDate() + i);

    const dayName = date.toLocaleDateString("he-IL", { weekday: "long" });
    const day = date.toLocaleDateString("he-IL", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });

    const dateKey = date.toISOString().split("T")[0]; // ✅ هذا السطر مهم

    this.days.push({
      dateObject: date,
      dayName,
      dateString: day,
      dateKey // ✅ لا تنسى تضيفه هنا
    });
  }
}
,
      selectDate(day) {
         this.selectedDate = day.dateKey; // نحدد التاريخ المختار
    const dateKey = day.dateKey;
    const readable = day.dayName + " - " + day.dateString;
    this.$emit("date-selected", {
      key: dateKey,
      readable: readable
    });
  }

  }
};
</script>

<style scoped>
.calendar {
  display: flex;
  width: 100%;
  gap: 12px;
  overflow-x: auto;
  direction: rtl;
  margin: 1rem 0;
}
.day-card {
  border: 1px solid #014342;
  border-radius: 10px;
  padding: 12px;
  text-align: center;
  background: #f9f9f9;
  min-width: 120px;
      display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.day-name {
  font-weight: 500;
  color: #000;
}
.date {
  font-size: 14px;
  color: #666;
}
.selected{
    background-color: #014342;
     border: 1px solid #014342;
  border-radius: 10px;
  padding: 12px;
  text-align: center;
  min-width: 120px;
}
.selected .day-name,
.selected .date
{
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar.vue